import { twMerge } from 'tailwind-merge';

import { TableBodyCell } from './TableBodyCell';

export const TableCellDate = ({
  date,
  className,
  withBorderBottom,
  isPast = false,
}) => {
  const textClassName = twMerge(
    'truncate font-medium text-[16px]/[24px]',
    className,
    isPast ? 'text-destructive-500' : 'text-base-1000',
  );

  if (!date) {
    return (
      <TableBodyCell withBorderBottom={withBorderBottom}>
        <span className={textClassName}>-</span>
      </TableBodyCell>
    );
  }

  const dateSplitted = date.split(', ');

  return (
    <TableBodyCell withBorderBottom={withBorderBottom}>
      <div className="flex flex-col truncate">
        <span className={textClassName}>{dateSplitted[0]}</span>
        <span className={textClassName}>{dateSplitted[1]}</span>
      </div>
    </TableBodyCell>
  );
};
